import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

// Keeps a single render error from blanking the whole console (which is exactly what
// the earlier engagements-shape bug did). Shows the message + a recover action instead.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="mx-auto mt-16 max-w-md rounded-xl border border-black/5 bg-white p-6 text-center shadow-sm">
          <h1 className="text-lg font-semibold text-ink">Something went wrong</h1>
          <p className="mt-2 break-words text-sm text-ink-soft">{this.state.error.message}</p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="mt-4 text-sm font-medium text-[var(--accent)] underline-offset-4 hover:underline"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
